import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, handleBackendFormErrors, tailFormItemLayout, unexpectedError } from '../../common_functions';

const Print = props => {
  const { section, id } = useParams();
  const [print, setPrint] = useState();
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    async function fetchData() {
      if (id != 'new') {
        try {
          setLoading(true);
          let { data } = await props.getItem('print_condition', id);
          setPrint(data);
          formRef.current.setFieldsValue(data);
        } catch (error) {
          unexpectedError(error);
        } finally {
          setLoading(false);
        }
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    setLoading(true);

    if (section === 'new' && print.id) {
      props.history.push(`/settings/prints-conditions/${print.id}`);
      setLoading(false);
      return;
    }

    let newState = { ...print, ...values };

    try {
      const response = await props.saveItem('print_condition', newState);

      if (response) {
        setLoading(false);
        notification['success']({
          message: 'Print saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/prints-conditions`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = errorField => {
    formRef.current.setFieldsValue(errorField[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/prints-conditions" }, { title: "Print Conditions Rating", href: "/settings/prints-conditions" }, { title: id !== 'new' ? `Edit Print Conditions Rating: ${id}` : 'Add Print Conditions Rating' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Print Conditions Rating: ${id}` : 'Add Print Conditions Rating'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id ? (
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <Form.Item label="ID(System generated)" name="id">
                      <Input placeholder={id} disabled />
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <Form.Item
                      label="Print Condition"
                      name="condition"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Print condition is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter print condition" />
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <Form.Item
                      label="Print Condition"
                      name="condition"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Print condition is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter print condition" />
                    </Form.Item>
                  </Col>
                </Row>
              )}

              <Row gutter={24}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item label="Print Condition Description" name="desc">
                    <Input.TextArea rows={4} Col placeholder="Enter print condition description..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => props.history.push('/settings/prints-conditions')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_prints_conditions, !!print ? print.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Print;
